import React, { useState, useEffect } from "react";
import Select from "react-select";
import { baseSelectStyles } from "../../shared/selectStyles";

const roleOptions = [
  { value: "admin", label: "Admin" },
  { value: "doctor", label: "Doctor" },
  { value: "receptionist", label: "Receptionist" },
  { value: "pharmacist", label: "Pharmacist" },
  { value: "lab_technician", label: "Lab Technician" },
];

const UserFormModal = ({show, onclose, onSave, user }) => {

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        role: "",
        password:""
    });
     const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        if (user){
            setFormData({
                name: user.name || "",
                email: user.email || "",
                role: user.role || "",
                password: ""
            });
        } else {
            setFormData({ name: "", email: "", role: "", password: ""});
        }
    }, [ user]);

    if (!show) return null;

    
    const handleRoleChange = (selectedOption) => {
        setFormData((prev) => ({ ...prev, role: selectedOption.value }));
    };

    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData((prev) => ({...prev, [name]: value}));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
         if (submitting) return;
         setSubmitting(true);
          try {
            onSave(formData);
            } finally {
            setSubmitting(false);
            }
    };

    return(
        <div className="popup">
            <div className="popup-content">

            <button
              onClick={onclose}
              type='button'
              className="pop-btn"

            >
              ✕
            </button>
                <h2 className="user-form-heading">
                    {user ? "Edit User" : "Add User"}
                </h2>

                <form onSubmit={handleSubmit} className="user-form space-y-3" autoComplete="off">
                    <input
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Name"
                        autoComplete="off"
                        className="w-full border rounded p-2"
                        required
                    />

                    <input
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="Email"
                        autoComplete="off"
                        className="w-full border rounded p-2"
                        required
                    />
                    {!user &&(
                    <input
                        name="password"
                        type="password"
                        value={formData.password}
                        onChange={handleChange}
                        placeholder="password"
                        autoComplete="new-password" 
                        className="w-full border rounded p-2"
                        required
                    />
                     )}
                      <Select
                        options={roleOptions}
                        value={roleOptions.find((opt) => opt.value === formData.role)}
                        onChange={handleRoleChange}
                        placeholder="Select role..."
                        className="w-[250px]"
                         styles={baseSelectStyles}
                    required
                    />


                    <div className="flex justify-end gap-[10px] pt-3">
                        <button
                        type="button"
                        onClick={onclose}
                        disabled={submitting}
                        className="secondary">
                        cancel
                        </button>

                        <button
                        type="submit"
                        className="primary"
                        disabled={submitting}
                        >
                         {submitting
                            ? user
                            ? "Updating..."
                            : "Saving..."
                            : user
                            ? "Update"
                            : "Save"}                              
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UserFormModal;